var _g, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "in_progress_status",
    "data-name": "in progress status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 22,
    viewBox: "0 0 98 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    fill: "#fbf8f3",
    stroke: "#b47722",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 22,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 21,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "In_Progress",
    "data-name": "In Progress",
    transform: "translate(27 15)",
    fill: "#b47714",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In Progress"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "acute_FILL0_wght400_GRAD0_opsz48",
    d: "M51.576,269.23a6.565,6.565,0,1,1,4.693-1.923A6.384,6.384,0,0,1,51.576,269.23Zm0-1.24a5.356,5.356,0,1,0-3.8-1.571A5.195,5.195,0,0,0,51.572,267.99Zm2.113-2.419.868-.868-2.336-2.357-.021-3.039h-1.24v3.556Zm-12.858-5.643v-1.24h3.308v1.24ZM40,263.235v-1.24h4.134v1.24Zm.827,3.308V265.3h3.308v1.24ZM51.576,262.615Z",
    transform: "translate(-35.026 -251.675)",
    fill: "#b47714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.343461d1f3a8bc4505f4bbbae2fb3c06.svg";
export { ForwardRef as ReactComponent };